import React from 'react'

const PaymentFailure = ({}) => { 
  
  return (
    <img src="icon_animated_error.gif" alt="logo" />
  )
}

export default PaymentFailure